import { User } from '../store/user/types';
import { apiRequest } from './api';

/**
 * Get the currently logged in user
 * @returns The current user data
 */
export const getCurrentUser = async (): Promise<User> => {
  return apiRequest<User>('/users/me');
};

/**
 * Update a user's role (admin only)
 * @param userId The ID of the user to update
 * @param role The new role
 * @returns The updated user data
 */
export const updateUserRole = async (userId: string, role: User['role']): Promise<User> => {
  return apiRequest<User>(`/users/${userId}/role`, {
    method: 'PUT',
    data: { role },
  });
};
